import React from 'react';
import CTAExpressStyled from './CTAExpress.styled';
//TODO: Remove happy houses
//import BackgroundImageSmall from '../../../public/images/blue-home-hero-small.png'
import ButtonLink from '../../components/Shared/ButtonLink';
import ExpressLogo from '../../../public/images/ExpressLogoSimple.png';
import InView from '../Shared/InView';
import SimpleAnimation from '../../styles/Components/SimpleAnimation';
import PropTypes from 'prop-types';

const CTAExpress = ({
  subHeader,
  backgroundImagePath,
  mobileBackgroundImagePath,
  header,
  ctaBackgroundColor,
  intro1,
  intro2,
  intro3,
  title = '',
  link = null,
  secondaryLink = null,
}) => {
  return (
    <InView>
      <CTAExpressStyled
        ctaBackgroundColor={ctaBackgroundColor}
        backgroundImage={backgroundImagePath}
        mobileBackgroundImage={mobileBackgroundImagePath}
      >
        <div className='inner'>
          <div className='logo-buttons'>
            <SimpleAnimation.img src={ExpressLogo} alt='Express Logo' />
            <SimpleAnimation.div delay={0.8} className='btn-container'>
              {link && link.to && link.title && (
                <ButtonLink
                  appearance='dark'
                  isExternal='true'
                  newTab='true'
                  {...link}
                >
                  {link.title}
                </ButtonLink>
              )}
              {secondaryLink && secondaryLink.to && secondaryLink.title && (
                <ButtonLink
                  outline='true'
                  appearance='dark'
                  isExternal='true'
                  newTab='true'
                  {...secondaryLink}
                >
                  {secondaryLink.title}
                </ButtonLink>
              )}
            </SimpleAnimation.div>
          </div>
          <div className='express-content'>
            <SimpleAnimation.h3 delay={0.2} className='type-h3'>
              {subHeader}
            </SimpleAnimation.h3>
            <SimpleAnimation.p delay={0.4} className='type-p'>
              {intro1}
            </SimpleAnimation.p>
            <SimpleAnimation.p delay={0.6} className='type-p'>
              {intro2}
            </SimpleAnimation.p>
            <SimpleAnimation.p delay={0.6} className='type-p'>
              {intro3}
            </SimpleAnimation.p>
          </div>
        </div>
      </CTAExpressStyled>
    </InView>
  );
};

CTAExpress.propTypes = {
  ctaBackgroundColor: PropTypes.string,
};

export default CTAExpress;
